import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledDocuments,
  StyledDocumentsList,
  StyledDocumentsItem,
  StyledDocumentsDownload,
  IconDocuments,
  StyledDocumentsName,
  StyledButtonsRight
} from './style';
import {
  Doc,
  Xls,
  Ppt,
  Pdf,
  Jpg,
  Folder,
  ArrowLink,
  Gen,
  Pencil,
  Trash
} from '../../../../assets/images';

import Breadcrumb from '../../core/Breadcrumb';
import Icon from '../../core/Icon';
import { Confirmation } from '../Employee/Edition';
import { DELETE_FILE, DELETE_FOLDER } from '../../../constants/literals/modals';

const getDocumentIcon = extension => {
  switch (extension) {
    case 'doc':
    case 'docx':
      return Doc;
    case 'pdf':
      return Pdf;
    case 'xls':
    case 'xlsx':
      return Xls;
    case 'jpg':
    case 'jpeg':
    case 'png':
      return Jpg;
    case 'ppt':
      return Ppt;
    case 'FOLDER':
      return Folder;
    case 'LINK':
      return ArrowLink;
    default:
      return Gen;
  }
};

const Documents = ({
  files,
  breadcrumb,
  onBreadcrumbClick,
  onFileClick,
  onEditFolderClick,
  onEditFileClick,
  onDeleteFolderClick,
  onDeleteFileClick
}) => {
  const [docToDelete, setDocToDelete] = useState(null);

  const isFolderToDelete =
    docToDelete && docToDelete.baseContentType === 'FOLDER';

  const onCloseDeleteModal = () => setDocToDelete(null);

  const onAcceptDeleteModal = () => {
    if (isFolderToDelete) {
      onDeleteFolderClick(docToDelete.id);
    } else {
      onDeleteFileClick(docToDelete.id);
    }
    setDocToDelete(null);
  };

  return (
    <>
      <StyledDocuments>
        <Breadcrumb dataList={breadcrumb} onClick={onBreadcrumbClick} />
        <StyledDocumentsList>
          {files &&
            files.map(doc => {
              const {
                id,
                fileExtension,
                title,
                manageable,
                baseContentType
              } = doc;
              return (
                <StyledDocumentsItem key={id}>
                  <StyledDocumentsDownload onClick={() => onFileClick(doc)}>
                    <IconDocuments svg={getDocumentIcon(fileExtension)} />
                    <StyledDocumentsName>{title}</StyledDocumentsName>
                  </StyledDocumentsDownload>
                  {manageable && (
                    <>
                      <StyledButtonsRight>
                        <Icon
                          hover
                          size="m"
                          color="main"
                          svg={Pencil}
                          onClick={() => {
                            if (baseContentType === 'FOLDER') {
                              onEditFolderClick(id);
                            } else if (baseContentType === 'DOCUMENT') {
                              onEditFileClick(id);
                            }
                          }}
                        />
                      </StyledButtonsRight>
                      <StyledButtonsRight>
                        <Icon
                          hover
                          size="m"
                          color="main"
                          svg={Trash}
                          onClick={() => {
                            if (
                              baseContentType === 'FOLDER' ||
                              baseContentType === 'DOCUMENT'
                            ) {
                              setDocToDelete(doc);
                            }
                          }}
                        />
                      </StyledButtonsRight>
                    </>
                  )}
                </StyledDocumentsItem>
              );
            })}
        </StyledDocumentsList>
      </StyledDocuments>
      {docToDelete && (
        <Confirmation
          onCloseModal={onCloseDeleteModal}
          onAcceptModal={onAcceptDeleteModal}
          data={isFolderToDelete ? DELETE_FOLDER : DELETE_FILE}
        />
      )}
    </>
  );
};

Documents.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string,
      fileExtension: PropTypes.string,
      folderName: PropTypes.string,
      clientPath: PropTypes.string
    })
  ),
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      txt: PropTypes.string,
      id: PropTypes.string
    })
  ),
  onBreadcrumbClick: PropTypes.func,
  onFileClick: PropTypes.func,
  onEditFolderClick: PropTypes.func,
  onEditFileClick: PropTypes.func,
  onDeleteFolderClick: PropTypes.func,
  onDeleteFileClick: PropTypes.func
};

export default Documents;
